import { useCallback, useEffect, useState } from "react";
import API from "../Api/Api";
import ENDPOINTS from "../Api/Endpoints";

/**
 * Fetches GET /app/platform-settings/public (no auth required).
 * @returns {{ data: object | null, loading: boolean, error: string | null, reload: () => void }}
 */
export function usePlatformSettingsPublic() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await API.get(ENDPOINTS.PLATFORM_SETTINGS_PUBLIC);
      const body = res?.data ?? res;
      const d = body?.data ?? body;
      setData(d && typeof d === "object" ? d : null);
    } catch (e) {
      setData(null);
      setError(e?.message || "Could not load");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: load };
}
